export enum Type {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

export const TYPES = [Type.Horizontal, Type.Vertical] as const;
